export default __webpack_public_path__ + "static/proximanova-semibold-woff2-8a633a5e83b2508ec26979c5e17d7114.woff2";